import { Address, getAddress } from "viem"

export type SinglePrice = {
  symbol: string
  price: number
  timestamp: number
}

export type PendingResolve = (value: SinglePrice | null) => void

export default class PriceAggregator {
  #pendingResolves: PendingResolve[] = []
  #pendingRejects: ((error: Error) => void)[] = []
  #pendingPrices: Address[] = []
  #timer?: ReturnType<typeof setTimeout> = undefined
  #chainId: number

  constructor(chainId: number) {
    this.#chainId = chainId
  }

  getPrice(asset: Address): Promise<SinglePrice | null> {
    this.scheduleBatch()
    this.#pendingPrices.push(asset)

    return new Promise<SinglePrice | null>((resolve, reject) => {
      this.#pendingResolves.push(resolve)
      this.#pendingRejects.push(reject)
    })
  }
  protected scheduleBatch() {
    if (this.#timer === undefined) {
      this.#timer = setTimeout(async () => {
        this.#timer = undefined
        await this.makeBatchNow()
      }, 0)
    }
  }

  protected async makeBatchNow() {
    const pendingResolves = this.#pendingResolves
    const pendingRejects = this.#pendingRejects
    const pendingPrices = this.#pendingPrices
    this.#pendingResolves = []
    this.#pendingRejects = []
    this.#pendingPrices = []

    const query = `assets=${pendingPrices.join(",")}`

    try {
      const response: Record<Address, SinglePrice> = await fetch(
        `/api/v1/price?chainId=${this.#chainId}&${query}`,
      ).then((res) => res.json())

      if (!Object.keys(response).length) throw new Error("No prices found")

      for (const [i, asset] of pendingPrices.entries()) {
        const pendingResolve = pendingResolves[i]
        const pendingReject = pendingRejects[i]

        if (!pendingResolve || !pendingReject) {
          throw new Error("No resolve or reject function found")
        } else {
          const price = response[getAddress(asset)]
          if (price) pendingResolve(price)
          else pendingResolve(null)
        }
      }
    } catch (error) {
      for (const pendingReject of pendingRejects) {
        pendingReject(error as Error)
      }
    }
  }
}
